export default "__VITE_ASSET__BuLj8pUt__"